import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { AxisLabelsLayerSpecification, ChartFeature } from '../chart-props';
import { getAxisRect } from '../helpers';

export function drawAxisLabelsLayer(
    pass: DrawPass,
    features: ChartFeature[],
    layer: AxisLabelsLayerSpecification,
    xAxis: Axis,
    yAxis: Axis
) {
    // TODO: other axes
    const font = pass.getFont(layer.layout.fontSize);

    if (layer.layout.axis === 'x') {
        let lastX = 0;
        const rect = getAxisRect(layer.layout.position ?? xAxis.getProps().position, pass);

        for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            if (layer.filter && !layer.filter(feature, i)) {
                continue;
            }

            if (feature.geometry.type !== 'Point') {
                continue;
            }
            const x = xAxis.project(feature.geometry.coordinates[0], pass.viewState) + 5;
            const y = pass.viewState.chartViewport.bottom + 10;
            if (!layer.layout.allowOverlap) {
                if (x - lastX < 15) {
                    continue;
                }
            }
            if (!rect.contains(x, y)) {
                continue;
            }
            const text = layer.layout.getText(feature);
            //if (xAxis.getProps().position === ChartPosition.top) {
            //
            //} else {
            pass.drawer.drawText(
                text.length > 5 ? text.substring(0, 5) + '...' : text,
                [x, y],
                {
                    alignment: 'end',
                    baseline: 'bottom',
                    font
                },
                {
                    color: layer.paint.textColor
                },
                -45
            );

            lastX = x;
            // }
        }
    } else {
        //
    }
}
